<script lang="ts" setup>
import type { ButtonHTMLAttributes } from 'vue'

const { to, binding, className } = withDefaults(
  defineProps<{
    className?: string
    to?: string
    binding?: ButtonHTMLAttributes
  }>(),
  {
    to: undefined,
    binding: {},
    className: ''
  }
)

const emits = defineEmits<{ (e: 'onClick'): void }>()
const nuxtLink = resolveComponent('NuxtLink')
</script>

<template lang="pug">
.hex-button(
  @click.prevent="emits('onClick')"
)
  Component(
    :is="to ? nuxtLink : 'button'"
    :class="className"
    :to="to"
    v-bind="binding || {}"
    :external="true"
  )
    slot
</template>

<style lang="sass" scoped>
.hex-button
  @apply w-fit relative px-2 py-1 cursor-pointer
  button, a
    @apply block clip-hex px-8 py-2
</style>
